import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

import SlideItem from './Slide/SlideItem'

import './slider.scss'
import Dott from '../../../icons/Dott'

export default class HomeSlider extends React.PureComponent {
  static propTypes = {
    results: PropTypes.arrayOf(PropTypes.any).isRequired,
  }

  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.sliderRef = React.createRef()
    this.transformCount = 0
    this.state = {
      maxDots: 5,
    }
  }

  componentDidMount() {
    const {
      maxDots
    } = this.state

    if (this.sliderRef.current) {

      const slickSlider = this.sliderRef.current.innerSlider;
      const dots = slickSlider.list.offsetParent.querySelectorAll('li');
      const dotsUl = slickSlider.list.offsetParent.querySelector('ul');

      if (dotsUl && dots.length > maxDots) {
        dotsUl.style.transform = 'translateX(0)';
        this.setBoundaries(slickSlider, 'default');
      } else if (dotsUl){
        dotsUl.classList.add('uptomax')
      }
    }
  }

  setBoundaries = (slick, state) => {
    const {
      maxDots
    } = this.state

    if (state === 'default') {
      const dots = slick.list.offsetParent.querySelectorAll('ul li');
      dots[maxDots - 1].classList.add('n-small');
    }
  };

  beforeChangeHandler = (currentSlide, nextSlide) => {
    const {
      maxDots
    } = this.state

    if (this.sliderRef.current) {
      const slickSlider = this.sliderRef.current.innerSlider;
      const dots = slickSlider.list.offsetParent.querySelectorAll('ul li');
      const dotsUl = slickSlider.list.offsetParent.querySelector('ul');
      const totalCount = dots.length;

      if (totalCount > maxDots) {
        if (nextSlide > currentSlide) {
          if (dots[nextSlide].classList.contains('n-small')) {
            if (!dots[dots.length - 1].classList.contains('n-small')) {
              this.transformCount += -46;
              dots[nextSlide].classList.remove('n-small');
              dots[nextSlide + 1].classList.add('n-small');
              dotsUl.style.transform = 'translateX(' + this.transformCount + 'px)';
              const pPointer = nextSlide - 3;
              dots[pPointer - 1].classList.remove('p-small');
              dots[pPointer].classList.add('p-small');
            }
          }
        } else {
          if (dots[nextSlide].classList.contains('p-small')) {
            if (!dots[0].classList.contains('p-small')) {
              this.transformCount += 46;
              dots[nextSlide].classList.remove('p-small');
              dots[nextSlide - 1].classList.add('p-small');
              dotsUl.style.transform = 'translateX(' + this.transformCount + 'px)';
              const nPointer = currentSlide + 1 === totalCount ? currentSlide : currentSlide + 3;
              dots[nPointer].classList.remove('n-small');
              dots[nPointer - 1].classList.add('n-small');
            }
          }
        }
      }
    }
  }

  next() {
    this.sliderRef.current.slickNext()
  }

  previous() {
    this.sliderRef.current.slickPrev()
  }

  render() {
    const {
      results,
    } = this.props

    const sliderSettings = {
      lazyLoad: true,
      arrows: false,
      dots: true,
      infinite: false,
      fade: true,
      touchThreshold: 15,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      accessibility: true,

      customPaging: (i) => {
        return (
          <div role={'button'} data-index={i}> <Dott/> </div>
        )
      },
      appendDots: dots => <div className={"slick-dots"}>
        <div className="slick-dots-container">
          <ul>{dots}</ul>
        </div>
      </div>,
      beforeChange: this.beforeChangeHandler,
    }

    return (

      <div className="hotel-intro">
        <Slider {...sliderSettings} ref={this.sliderRef}>
          {results.map((item, key) => (
            <SlideItem
              key={key}
              item={item}
              arrowNext={this.next}
              arrowPrev={this.previous}
            >
              {key + 1}
            </SlideItem>
          ))}
        </Slider>
      </div>
    )
  }
}
